import React from "react"
import { Helmet } from "react-helmet"
import { Value } from "contentful-layout-field"
import SEO from "../components/boilerplate/seo"
import LayoutBuilder from "../components/LayoutBuilder"
import { createContentfulImageMap } from "../utils"
import useBreakpointValue from "../hooks/useBreakpointValue"
import { bp } from "../utils/MediaQueries"
import { HomePageQuery } from "../../graphql-types"

type HomePageProps = {
  data: HomePageQuery
  pageContext: {
    layoutData: Value
    seoTitle: string
    seoDescription: string
  }
  location: Location
}

const HomePage: React.FC<HomePageProps> = ({ data, pageContext, location }) => {
  const desktopImageMap = createContentfulImageMap(data.images)
  const mobileImageMap = createContentfulImageMap(data.mobileImages)
  const imageMap = useBreakpointValue(bp(mobileImageMap, desktopImageMap))
  return (
    <>
      <SEO
        title={pageContext.seoTitle}
        description={pageContext.seoDescription}
        location={location}
      />
      <Helmet>
        <link
          type="application/opensearchdescription+xml"
          rel="search"
          href="opensearch.xml"
        />
      </Helmet>
      <LayoutBuilder
        data={pageContext.layoutData}
        imageMap={imageMap}
        delayRender
      />
    </>
  )
}

export default HomePage
